export function sanitizarCnpj(valor) {
    const raw = valor.replace(/[^A-Z0-9]/gi, '').toUpperCase();

    const alfanumerico = raw.slice(0, 12);
    const dv           = raw.slice(12).replace(/[^0-9]/g, '').slice(0, 2);

    return alfanumerico + dv;
}

export function sanitizarRadical(valor) {
    return valor.replace(/[^A-Z0-9]/gi, '').toUpperCase().slice(0, 8);
}


// WEBPACK FOOTER //
// ./src/utils/sanitizar.js